<template>
  <div class="login-container">
    <section class="section">
      <div class="content" v-loading="loading">
        <h2>智能通讯融合平台</h2>
        <div class="form">
          <div
            :class="{
              'form-item': true === true,
              focus: tShow === 1,
              wrong: tShow === 2,
            }"
            v-if="isStandalone !== 'true'"
          >
            <label class="item-label" style="margin-right: -50px">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#iconzuhuguanli" />
              </svg>
            </label>
            <div class="input-group">
              <input
                class="inputbox"
                type="text"
                placeholder="租户编号"
                v-model="loginForm.tenantId"
                name="tenantId"
                v-on:focusin="changeClass($event)"
                v-on:focusout="validateValue($event, loginForm.tenantId)"
                @keyup.enter="login()"
              />
            </div>
            <div class="tips-wrong">{{ tMsg }}</div>
          </div>

          <div
            :class="{
              'form-item': true === true,
              focus: uShow === 1,
              wrong: uShow === 2,
            }"
          >
            <label class="item-label" style="margin-right: -50px">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#iconzhanghao" />
              </svg>
            </label>
            <div class="input-group">
              <input
                class="inputbox"
                type="text"
                placeholder="坐席账号"
                v-model="loginForm.username"
                name="username"
                v-on:focusin="changeClass($event)"
                v-on:focusout="validateValue($event, loginForm.username)"
                @keyup.enter="login()"
              />
            </div>
            <div class="tips-wrong">{{ uMsg }}</div>
          </div>

          <div
            class="form-item"
            :class="{
              'form-item': true === true,
              focus: pShow === 1,
              wrong: pShow === 2,
            }"
          >
            <label class="item-label" style="margin-right: -50px">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#iconmima" />
              </svg>
            </label>
            <div class="input-group input-group-pass">
              <input
                class="inputbox"
                :type="pwdType"
                placeholder="密码"
                v-model="loginForm.password"
                name="password"
                v-on:focusin="changeClass($event)"
                v-on:focusout="validateValue($event, loginForm.password)"
                @keyup.enter="login()"
              />
              <span @click="showPwd">
                <svg class="icon icon-eye" aria-hidden="true">
                  <use
                    :xlink:href="
                      pwdType === 'password'
                        ? '#iconyincangbukechakan'
                        : '#iconyanjing'
                    "
                  />
                </svg>
              </span>
            </div>
            <div class="tips-wrong">{{ pMsg }}</div>
          </div>
          <!-- 滑块验证 -->
          <div style="width:100%">
              <slider :onsuccess="onVerifySucc"></slider>
          </div>

          <div class="btn-wrapper">
            <button :class="loginBtnCls" href @click="login">登 录</button>
          </div>
          <div class="bottom-option" v-if="!this.$store.getters.isStandalong">
            <a href="#" class="goto-loginhelp" @click="goToLoginHelp"
              >无法登录？点我解决</a
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Slider from './slider'
const workBenchUrl = window.$envUtils('VUE_APP_WB_URL')
export default {
  name: 'Login',
  components: {
    Slider
  },
  data() {
    return {
      loginForm: {
        tenantId: '',
        username: '',
        password: ''
      },
      loginBtnCls: 'btn btn-disabled',
      pwdType: 'password',
      uMsg: '',
      pMsg: '',
      tMsg: '',
      uShow: 0,
      pShow: 0,
      tShow: 0,
      isStandalone: window.$envUtils('VUE_APP_STANDALONE'),
      loading: false,
      verifySuccess: false // 滑块验证成功
    }
  },
  mounted() {
    this.$store.commit('user/resetState')
    this.$store.commit('role/resetState')
  },
  methods: {
    ...mapActions('user', ['handleLogin', 'getUserInfo']),
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }
    },
    changeClass(e) {
      if (e.currentTarget.name === 'username') {
        this.uShow = 1
        if (this.pShow === 1) {
          this.pShow = 0
        }
        if (this.tShow === 1) {
          this.tShow = 0
        }
        this.uMsg = ''
      } else if (e.currentTarget.name === 'password') {
        this.pShow = 1
        if (this.uShow === 1) {
          this.uShow = 0
        }
        if (this.tShow === 1) {
          this.tShow = 0
        }
        this.pMsg = ''
      } else if (e.currentTarget.name === 'tenantId') {
        this.tShow = 1
        if (this.uShow === 1) {
          this.uShow = 0
        }
        if (this.pShow === 1) {
          this.pShow = 0
        }
        this.tMsg = ''
      }
    },
    validateValue(e, value) {
      if (e.currentTarget.name === 'username') {
        if (value.trim() === '') {
          this.uMsg = '请输入用户名'
          this.uShow = 2
        } else {
          this.uMsg = ''
          this.uShow = 0
          this.tMsg = ''
          this.tShow = 0
        }
      } else if (e.currentTarget.name === 'password') {
        if (value.trim().length < 5) {
          this.pMsg = '密码不能少于5位'
          this.pShow = 2
        } else {
          this.pMsg = ''
          this.pShow = 0
          this.tMsg = ''
          this.tShow = 0
        }
      } else if (e.currentTarget.name === 'tenantId') {
        if (value.trim() === '') {
          this.tMsg = '请输入租户编号'
          this.tShow = 2
        } else {
          this.uMsg = ''
          this.uShow = 0
          this.pMsg = ''
          this.pShow = 0
        }
      }
    },
    login() {
      if (!this.verifySuccess) return
      this.loading = true
      const me = this
      const tenantId = me.loginForm.tenantId.trim()
      const username = me.loginForm.username.trim()
      const password = me.loginForm.password.trim()

      if (this.isStandalone !== 'true' && tenantId === '') {
        this.tMsg = '请输入租户编号'
        this.tShow = 2
        this.loading = false
        return
      }
      if (username === '') {
        this.uMsg = '请输入用户名'
        this.uShow = 2
        this.loading = false
        return
      }
      if (password === '') {
        this.pMsg = '请输入密码'
        this.pShow = 2
        this.loading = false
        return
      }
      if (password.trim().length < 5) {
        return
      }
      this.handleLogin({ tenantId, username, password }).then(res => {
        if (res.code === 2000) {
          if (res.data.roleType === '1' || res.data.userId === this.$global.defaultBuiltinAdminId) {
            me.$router.push('/').catch(() => {
              const routes = this.$store.state.user.authRoutes
              me.$router.push(routes[0].redirect).catch(() => { })
            })
          } else {
            // 跳转坐席平台
            window.location.href =
              workBenchUrl +
              '?token=' +
              localStorage.getItem('Authorization') +
              '&tenantId=' +
              localStorage.getItem('X-TENANT-ID')
          }
        } else {
          this.uMsg = '输入错误请重新输入'
          this.uShow = 2
          this.pMsg = '输入错误请重新输入'
          this.pShow = 2
          this.tMsg = '输入错误请重新输入'
          this.tShow = 2
        }
        this.loading = false
      }).catch(err => {
        err = 1
        this.loading = false
      })
    },
    // 无法登录，跳转登录帮助中心【云平台环境专属功能】
    goToLoginHelp() {
      this.$router.push({ path: '/loginHelp' })
    },
    // 滑块验证成功时候的回调函数
    onVerifySucc() {
      this.verifySuccess = true
      this.loginBtnCls = 'btn'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/login/login.css";
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
  -webkit-text-fill-color: #333 !important;
}
.login-container .section .content {
  .form .form-item .input-group .inputbox {
    height: 100%;
  }
  .btn-wrapper .btn {
    &:focus {
      outline: none;
    }
  }
}
</style>
